export default __webpack_public_path__ + "static/media/hod.8a262fd1.jpg";